import React, { Suspense } from 'react'
import { PreviewAlert } from '../../elements'
import styles from './Page.module.scss'
import { DynamicComponent } from '~elements'
import { useModal } from 'utils/hooks/useModal'
import { isComponentOfType } from 'utils'
import { PageProps, LostandFoundProps, ModalProps } from '~types'

const Page = ({ content, preview, lostandfoundData }: PageProps) => {
  const { body } = content
  const { blocks = [] } = body || {}

  // Manage Modals that open on page load
  const { isModalOpen, closeModal } = useModal(true)

  const componentsList = Array.isArray(blocks)
    ? blocks.map(block => {
        const isModalComponent = isComponentOfType<ModalProps>(block, 'Modal')
        const isLostandFoundComponent = isComponentOfType<LostandFoundProps>(block, 'LostandFound')

        const enhancedBlock = {
          ...block,
          ...(isModalComponent && {
            handleModalClose: () => {
              closeModal()
            },
            isOpen: isModalOpen
          }),
          ...(isLostandFoundComponent && { lostandfoundData: lostandfoundData })
        }

        return <DynamicComponent key={block?.id} block={enhancedBlock} />
      })
    : null

  return (
    <main>
      <Suspense fallback={<div>Loading...</div>}>{componentsList}</Suspense>
      {preview && (
        <div className={styles.previewAlertContainer}>
          <PreviewAlert />
        </div>
      )}
    </main>
  )
}

export default Page
